// Card Images
import tetrisCardImg from "../img/tetrisCard.jpg";
import snakeCardImg from "../img/snakeCard.jpg";
import memoryCardImg from "../img/memoryCard.jpg";
import ticTacToeCardImg from "../img/ticTacToeCard.png";
import flappyBirdCardImg from "../img/flappyBirdCard.jpg";

export const games = [
  { image: tetrisCardImg, title: "Tetris", routeLink: "tetris" },
  { image: snakeCardImg, title: "Snake", routeLink: "snake" },
  { image: memoryCardImg, title: "Memory Game", routeLink: "memorygame" },
  { image: ticTacToeCardImg, title: "Tic Tac Toe", routeLink: "tictactoe" },
  { image: flappyBirdCardImg, title: "Flappy Bird", routeLink: "flappybird" },
];
